module.exports = __webpack_public_path__ + "static/media/settings.f84ee912.svg";